import PropTypes from 'prop-types';
import { List } from 'immutable';
import ChatHeadingConfigPropType from 'conversations-prop-types/prop-types/ChatHeadingConfigPropType';
import { RIGHT_ALIGNED, WidgetLocationProp } from '../constants/WidgetLocations';
import WidgetHeader from './WidgetHeader';
import VisitorWidgetStyleWrapper from '../../presentation-components/VisitorWidgetStyleWrapper';
import styled from 'styled-components';
import WidgetViews from '../proptypes/WidgetViews';
import { THREAD_VIEW } from '../constants/views';
import { getBrandStyle } from '../util/color';
import KBNavigation from './KBNavigation';
import { KBSearchProvider } from '../../knowledge-base/context/KBSearchProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WidgetBodyDiv = styled.div.withConfig({
  displayName: "VisitorWidget__WidgetBodyDiv",
  componentId: "sc-1wbojys-0"
})(["display:flex;flex-direction:column;height:100%;background-color:#fff;overflow:auto;border-start-end-radius:10px;"]);
export const WidgetBodyDivWrapper = styled.div.withConfig({
  displayName: "VisitorWidget__WidgetBodyDivWrapper",
  componentId: "sc-1wbojys-1"
})(["flex:1;min-height:0;display:flex;flex-direction:column;", ";"], ({
  $background
}) => getBrandStyle($background));
const VisitorWidget = ({
  backButtonDisabled,
  browserWindowHeight,
  browserWindowWidth,
  chatHeadingConfig,
  chatHeadingResponders,
  children,
  closeWidget,
  coloring,
  createNewThread,
  customHeaderText = null,
  inline = false,
  isPreview = false,
  isThreadAssigned = false,
  kbArticleDeepLink,
  restorePreviousViewFromKBArticle,
  mobile = false,
  navigateToKnowledgeBaseArticle,
  navigateToThreadList,
  officeHoursMessage,
  setWidgetSize,
  showAvailabilityMessage,
  showBackButton,
  size,
  style,
  toggleWidgetSizeForKBArticle,
  typicalResponseTimeMessage,
  unseenThreadsCountExcludingCurrentThread,
  view = THREAD_VIEW,
  viewKBArticleExpanded,
  widgetLocation = RIGHT_ALIGNED,
  widgetSize,
  updateView,
  kbNavigationEnabled
}) => {
  return /*#__PURE__*/_jsx(VisitorWidgetStyleWrapper, {
    browserWindowHeight: browserWindowHeight,
    browserWindowWidth: browserWindowWidth,
    inline: inline,
    size: size,
    style: style,
    mobile: mobile,
    widgetLocation: widgetLocation,
    widgetSize: widgetSize,
    children: /*#__PURE__*/_jsxs(KBSearchProvider, {
      children: [/*#__PURE__*/_jsx(WidgetHeader, {
        backButtonDisabled: backButtonDisabled,
        browserWindowHeight: browserWindowHeight,
        chatHeadingConfig: chatHeadingConfig,
        coloring: coloring,
        chatHeadingResponders: chatHeadingResponders,
        createNewThread: createNewThread,
        customHeaderText: customHeaderText,
        inline: inline,
        isThreadAssigned: isThreadAssigned,
        kbArticleDeepLink: kbArticleDeepLink,
        restorePreviousViewFromKBArticle: restorePreviousViewFromKBArticle,
        mobile: mobile,
        navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle,
        navigateToThreadList: navigateToThreadList,
        officeHoursMessage: officeHoursMessage,
        onClose: closeWidget,
        preview: isPreview,
        toggleWidgetSizeForKBArticle: toggleWidgetSizeForKBArticle,
        setWidgetSize: setWidgetSize,
        showAvailabilityMessage: showAvailabilityMessage,
        showBackButton: showBackButton,
        typicalResponseTimeMessage: typicalResponseTimeMessage,
        unseenThreadsCountExcludingCurrentThread: unseenThreadsCountExcludingCurrentThread,
        view: view,
        viewKBArticleExpanded: viewKBArticleExpanded
      }), /*#__PURE__*/_jsx(WidgetBodyDivWrapper, {
        $background: coloring.accentColor,
        kbNavigationEnabled: kbNavigationEnabled,
        children: /*#__PURE__*/_jsx(WidgetBodyDiv, {
          children: children
        })
      }), kbNavigationEnabled && /*#__PURE__*/_jsx(KBNavigation, {
        coloring: coloring,
        updateView: updateView,
        view: view
      })]
    })
  });
};
VisitorWidget.propTypes = {
  backButtonDisabled: PropTypes.bool,
  browserWindowHeight: PropTypes.number.isRequired,
  browserWindowWidth: PropTypes.number.isRequired,
  chatHeadingConfig: ChatHeadingConfigPropType.isRequired,
  chatHeadingResponders: PropTypes.instanceOf(List),
  children: PropTypes.node.isRequired,
  closeWidget: PropTypes.func,
  coloring: PropTypes.object.isRequired,
  createNewThread: PropTypes.func,
  customHeaderText: PropTypes.string,
  inline: PropTypes.bool.isRequired,
  isPreview: PropTypes.bool.isRequired,
  isThreadAssigned: PropTypes.bool.isRequired,
  kbArticleDeepLink: PropTypes.string,
  kbNavigationEnabled: PropTypes.bool,
  mobile: PropTypes.bool.isRequired,
  navigateToKnowledgeBaseArticle: PropTypes.func,
  navigateToThreadList: PropTypes.func,
  officeHoursMessage: PropTypes.string,
  restorePreviousViewFromKBArticle: PropTypes.func,
  setWidgetSize: PropTypes.func,
  showAvailabilityMessage: PropTypes.bool,
  showBackButton: PropTypes.bool.isRequired,
  size: PropTypes.string,
  style: PropTypes.object,
  toggleWidgetSizeForKBArticle: PropTypes.func,
  typicalResponseTimeMessage: PropTypes.string,
  unseenThreadsCountExcludingCurrentThread: PropTypes.number,
  updateView: PropTypes.func,
  view: WidgetViews,
  viewKBArticleExpanded: PropTypes.bool,
  widgetLocation: WidgetLocationProp,
  widgetSize: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }).isRequired
};
VisitorWidget.displayName = 'VisitorWidget';
export default VisitorWidget;